import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Tc } from '../../../../core/_infrastructure/types/common';
import { NumeroSeguridadItemResultsViewModel, NumeroSeguridadViewModel } from './numerosseguridad.types';



///https://angular.io/tutorial/toh-pt6
//https://malcoded.com/posts/angular-backend-asp-core


@Injectable()
export class NumerosSeguridadExService {    

    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {

    }
    
    getNumerosSeguridadPagedByFilter(params: HttpParams): Observable<NumeroSeguridadItemResultsViewModel> {
        return this.http
            .get<NumeroSeguridadItemResultsViewModel>(this.baseUrl + 'api/exportacion/envioex/numerosSeguridadPagedByFilter/', { params: params }).pipe();
    }    

    getNumeroSeguridad(id: number): Observable<NumeroSeguridadViewModel> {
        return this.http
            .get<NumeroSeguridadViewModel>(this.baseUrl + 'api/exportacion/envioex/getNumeroSeguridad/' + id).pipe();
    }
    
    createNumeroSeguridad(numeroSeguridad: NumeroSeguridadViewModel): Observable<any> {
        return this.http
            .post<NumeroSeguridadViewModel>(this.baseUrl + 'api/exportacion/envioex/postNumeroSeguridad', numeroSeguridad).pipe();
    }

    editNumeroSeguridad(numeroSeguridad: NumeroSeguridadViewModel): Observable<any> {
        return this.http
            .put<NumeroSeguridadViewModel>(this.baseUrl + 'api/exportacion/envioex/putNumeroSeguridad', numeroSeguridad).pipe();
    }

    deleteNumeroSeguridad(id: number | null): Observable<any> {
        return this.http
            .delete<NumeroSeguridadViewModel>(this.baseUrl + 'api/exportacion/envioex/deleteNumeroSeguridad/' + id).pipe();
    }

    

   

    

   

    
}
